"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReDragModal;
var _DragHandle = _interopRequireDefault(require("@mui/icons-material/DragHandle"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent/DialogContent.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper/Paper.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _react = _interopRequireDefault(require("react"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _reactResizable = require("react-resizable");
require("react-resizable/css/styles.css");
var _hooks = require("../hooks");
var _icons = require("../icons");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ReDragModal({
  children,
  closeModal,
  heading,
  subtitle = null,
  submitText = 'Save',
  showFooter = false,
  disableSubmit = false,
  onSubmit = null,
  resizeable = false,
  resizeProps,
  PopupActionPerspectiveToolbarComponents = null
}) {
  (0, _hooks.useHotKey)({
    key: 'Escape'
  }, closeModal);
  if (!children) return null;
  const height = resizeProps?.height ?? window.innerHeight * 0.8;
  const width = resizeProps?.width ?? window.innerWidth * 0.8;
  const getContent = () => {
    const body = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      sx: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...(!resizeable && {
          height,
          width
        })
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        sx: {
          pl: 1,
          cursor: 'move'
        },
        children: [heading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
          sx: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              gap: 1
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DragHandle.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
              variant: "h6",
              display: "inline",
              children: heading
            })]
          }), PopupActionPerspectiveToolbarComponents && PopupActionPerspectiveToolbarComponents, /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
            onClick: closeModal,
            size: "large",
            sx: {
              color: 'inherit'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Close, {})
          })]
        }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "subtitle1",
          children: subtitle
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.default, {
        sx: {
          p: 1,
          pt: 0
        },
        children: children
      }), showFooter && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          sx: {
            float: 'right'
          },
          color: "primary",
          variant: "contained",
          disabled: disableSubmit,
          onClick: onSubmit,
          children: submitText
        })
      })]
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, {
      elevation: 10,
      sx: {
        borderRadius: '8px',
        position: 'absolute',
        zIndex: 5
      },
      children: resizeable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactResizable.ResizableBox, {
        minConstraints: [200, 200],
        height,
        width,
        children: body
      }) : body
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDraggable.default, {
    cancel: '[class*="MuiDialogContent-root"], .react-resizable-handle',
    defaultPosition: {
      x: (window.innerWidth - width) / 2,
      y: (window.innerHeight - height) / 2
    },
    children: getContent()
  });
}